<template>
  <div class="breadcrumbs">
    <div>
      <transition name="fade" appear>
        <router-link :to="{ name: 'Home' }">Home</router-link>
      </transition>
      <transition name="fade" appear>
        <div v-show="progressStep > 1">
          <span class="divider">/</span>
          <router-link :to="{ name: 'Interested In' }">Step 1</router-link>
        </div>
      </transition>
      <transition name="fade" appear>
        <div v-show="progressStep > 2 && $store.state.currentStepTwo !== ''">
          <span class="divider">/</span>
          <router-link :to="{ name: $store.state.currentStepTwo }"
            >Step 2</router-link
          >
        </div>
      </transition>
      <transition name="fade" appear>
        <div v-show="progressStep > 3">
          <span class="divider">/</span>
          <router-link :to="{ name: 'Ideal Benefits' }">Step 3</router-link>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "Breadcrumbs",
  data: function () {
    return {
      progressStep: 0,
    };
  },
  mounted() {
    this.setProgress(this.$route.name);
  },
  watch: {
    "$route.name"(to, from) {
      this.setProgress(to);
    },
  },
  methods: {
    setProgress(to) {
      switch (to) {
        case "Home":
          this.progressStep = 0;
          break;
        case "Interested In":
          this.progressStep = 1;
          break;
        case "Ideal Benefits":
          this.progressStep = 3;
          break;
        case "Recommendation":
          this.progressStep = 4;
          break;
        default:
          this.progressStep = 2;
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.breadcrumbs {
  flex-grow: 1;
  padding: 0 50px;
  > div {
    display:contents;
  }
  @media (max-width: 500px) {
    position: absolute;
    left: 0;
    top: 80px;
    width: 100%;
    height: calc(100vh - 80px);     
    display: grid;  
    place-items: center;
    box-sizing: border-box;
    opacity: 0;
    pointer-events: none;
    transition: all 0.8s cubic-bezier(0.075, 0.82, 0.165, 1); 
    background-image:url('~@/assets/images/mobile-bg.jpg');
    background-size: cover;
    > div {
      display:flex;
      flex-direction: column;
      gap:5px;
      text-align: center;
      > div {
        display: contents;
      }
    }
    .divider {
      display: none;
    }
    a {
      font-size: 2rem;
    }
  }
  &.show-mobile {
    opacity:1;
    pointer-events: all;
    z-index: 2;
  }
}
div {
  display: inline;
}
a,
.divider {
  letter-spacing: 0;
  line-height: 1;
  color: #fff;
  text-transform: uppercase;
  font-family: "Heading Pro";
  font-weight: bold;
}
a {
  padding: 10px;
  text-decoration: none;
  user-select: none;
  &.router-link-active {
    pointer-events: none;
  }
  @media (hover: hover) {
    transition: color 0.8s cubic-bezier(0.075, 0.82, 0.165, 1);
    &:hover {
      color: var(--logo-red);
    }
  }
}
</style>